export default __webpack_public_path__ + "static/media/revoke.2fb4e6d0.png";